

import React, { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import { Button, Badge } from 'reactstrap';
import Checkbox from '@material-ui/core/Checkbox';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class QuickPay extends Component{

    constructor(props){
        super(props);
        this.state = {
            APIName: "quickpay",
            APIUser: "",
            APIPass: "",
            EasyApiUser: "",
            EasyApiPassword: "",
            ClientId: "",
            ApiAddress: "",
            PeoId: "",
            CustomFieldNameLegacyEmployeeId: "",
            CustomFieldNameUserId: "",
            CustomFieldNameJobId: "",
            UseSalary: false,
            ProjAndJobAssignableToAll: false,
            loadingQuickPay: false,
            type: 'password',
            APIPasswordType: 'password',
            isAutenticated: true

        };
        this.handleApiUser = this.handleApiUser.bind(this);
        this.handleApiPass = this.handleApiPass.bind(this);
        this.handleEasyApiUser = this.handleEasyApiUser.bind(this);
        this.handleEasyApiPassword = this.handleEasyApiPassword.bind(this);
        this.handleClientID = this.handleClientID.bind(this);
        this.handlePeoId = this.handlePeoId.bind(this);
        this.handleApiAddress = this.handleApiAddress.bind(this);
        this.handleCustomFieldNameUserId = this.handleCustomFieldNameUserId.bind(this);
        this.handleCustomFieldNameJobId = this.handleCustomFieldNameJobId.bind(this);
        this.handleCustomFieldNameLegacyEmployeeId = this.handleCustomFieldNameLegacyEmployeeId.bind(this);
        this.handleUseSalary = this.handleUseSalary.bind(this);
        this.handleProjAndJobAssignableToAll = this.handleProjAndJobAssignableToAll.bind(this);
        this.showHide = this.showHide.bind(this);
        this.showHideAPIPasswordType = this.showHideAPIPasswordType.bind(this);
    }  

    showHide(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          type: this.state.type === 'input' ? 'password' : 'input'
        })  
    }
      showHideAPIPasswordType(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          APIPasswordType: this.state.APIPasswordType === 'input' ? 'password' : 'input'
        })  
    }
    componentDidMount(){

        var QuickPaymList = this.props.DataQuickPay;

        var QuickPay = QuickPaymList.find(x=> x.ALIAS === this.state.APIName);  
        var QuickPayValue = JSON.parse(QuickPay.VALUE);
        var UserName = QuickPayValue.UserName === null || QuickPayValue.UserName === undefined   ? "" :  QuickPayValue.UserName;
        var Pass = QuickPayValue.Password === null || QuickPayValue.Password === undefined   ? "" :  QuickPayValue.Password;
        var EasyApiUser = QuickPayValue.EasyApiUser === null || QuickPayValue.EasyApiUser === undefined   ? "" :  QuickPayValue.EasyApiUser;
        var EasyApiPassword = QuickPayValue.EasyApiPassword === null || QuickPayValue.EasyApiPassword === undefined   ? "" :  QuickPayValue.EasyApiPassword;
        var PeoId = QuickPayValue.PeoId === null || QuickPayValue.PeoId === undefined   ? "" :  QuickPayValue.PeoId;
        var ClientId = QuickPayValue.ClientId === null || QuickPayValue.ClientId === undefined   ? "" :  QuickPayValue.ClientId;
        var ApiAddress = QuickPayValue.ApiAddress === null || QuickPayValue.ApiAddress === undefined   ? "" :  QuickPayValue.ApiAddress;
        var CustomFieldNameUserId = QuickPayValue.CustomFieldNameUserId === null || QuickPayValue.CustomFieldNameUserId === undefined   ? "" :  QuickPayValue.CustomFieldNameUserId;
        var CustomFieldNameLegacyEmployeeId = QuickPayValue.CustomFieldNameLegacyEmployeeId === null || QuickPayValue.CustomFieldNameLegacyEmployeeId === undefined   ? "" :  QuickPayValue.CustomFieldNameLegacyEmployeeId;
        var CustomFieldNameJobId = QuickPayValue.CustomFieldNameJobId === null || QuickPayValue.CustomFieldNameJobId === undefined   ? "" :  QuickPayValue.CustomFieldNameJobId;
        var UseSalary = QuickPayValue.UseSalary === null || QuickPayValue.UseSalary === undefined   ? "" :  QuickPayValue.UseSalary;
        var ProjAndJobAssignableToAll = QuickPayValue.ProjAndJobAssignableToAll === null || QuickPayValue.ProjAndJobAssignableToAll === undefined   ? "" :  QuickPayValue.ProjAndJobAssignableToAll;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = UserName;
        stateCopy.APIPass = Pass;
        stateCopy.EasyApiUser = EasyApiUser;
        stateCopy.EasyApiPassword = EasyApiPassword;
        stateCopy.PeoId = PeoId;
        stateCopy.ClientId = ClientId;
        stateCopy.ApiAddress = ApiAddress;
        stateCopy.CustomFieldNameUserId = CustomFieldNameUserId;
        stateCopy.CustomFieldNameLegacyEmployeeId = CustomFieldNameLegacyEmployeeId;
        stateCopy.CustomFieldNameJobId = CustomFieldNameJobId;
        stateCopy.UseSalary = UseSalary;
        stateCopy.ProjAndJobAssignableToAll = ProjAndJobAssignableToAll;
        this.setState(stateCopy);
    }

    handleApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = value;
        this.setState(stateCopy);    
    }
    handleApiPass(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIPass = value;
        this.setState(stateCopy);    
    }
    handleEasyApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EasyApiUser = value;
        this.setState(stateCopy);    
    }
    handleEasyApiPassword(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EasyApiPassword = value;
        this.setState(stateCopy);    
    }
    handlePeoId(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.PeoId = value;
        this.setState(stateCopy);    
    }
    handleClientID(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ClientId = value;
        this.setState(stateCopy);    
    }
    handleApiAddress(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ApiAddress = value;
        this.setState(stateCopy);    
    }
    handleCustomFieldNameUserId(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.CustomFieldNameUserId = value;
        this.setState(stateCopy);    
    }
    handleCustomFieldNameLegacyEmployeeId(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.CustomFieldNameLegacyEmployeeId = value;
        this.setState(stateCopy);    
    }
    handleCustomFieldNameJobId(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.CustomFieldNameJobId = value;
        this.setState(stateCopy);    
    }
    handleUseSalary(event){
        var value = event.target.checked;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.UseSalary = value;
        this.setState(stateCopy);    
    }
    handleProjAndJobAssignableToAll(event){
        var value = event.target.checked;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ProjAndJobAssignableToAll = value;
        this.setState(stateCopy);    
    }

    ValidateSaveQuickPay(){

        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var PeoId = this.state.PeoId;
        var ClientId = this.state.ClientId;
        var ApiAddress = this.state.ApiAddress;
        var CustomFieldNameUserId = this.state.CustomFieldNameUserId;
        var CustomFieldNameLegacyEmployeeId = this.state.CustomFieldNameLegacyEmployeeId;
        var CustomFieldNameJobId = this.state.CustomFieldNameJobId;

        if(UserName === null || UserName === "" || UserName === undefined)
        {
            toast.error("Client API User field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Pass === null || Pass === "" || Pass === undefined)
        {
            toast.error("Client API Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(PeoId === null || PeoId === "" || PeoId === undefined)
        {
            toast.error("PeoID field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(ClientId === null || ClientId === "" || ClientId === undefined)
        {
            toast.error("ClientId field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(ApiAddress === null || ApiAddress === "" || ApiAddress === undefined)
        {
            toast.error("Api Access field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(CustomFieldNameUserId === null || CustomFieldNameUserId === "" || CustomFieldNameUserId === undefined)
        {
            toast.error("UserId CustomField field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(CustomFieldNameLegacyEmployeeId === null || CustomFieldNameLegacyEmployeeId === "" || CustomFieldNameLegacyEmployeeId === undefined)
        {
            toast.error("Legacy CustomField field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(CustomFieldNameJobId === null || CustomFieldNameJobId === "" || CustomFieldNameJobId === undefined)
        {
            toast.error("JobId CustomField field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        return true;
    }
   
    SaveQuickPay(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var EasyApiUser = this.state.EasyApiUser;
        var EasyApiPassword = this.state.EasyApiPassword;
        var PeoId = this.state.PeoId;
        var ClientId = this.state.ClientId;
        var ApiAddress = this.state.ApiAddress;
        var CustomFieldNameUserId = this.state.CustomFieldNameUserId;
        var CustomFieldNameLegacyEmployeeId = this.state.CustomFieldNameLegacyEmployeeId;
        var CustomFieldNameJobId = this.state.CustomFieldNameJobId;
        var UseSalary = this.state.UseSalary;
        var ProjAndJobAssignableToAll = this.state.ProjAndJobAssignableToAll;
        var CompanyCode = this.props.CompanyCode;
        var QuickPayList = this.props.DataQuickPay;
        var QuickPay = QuickPayList.find(x=> x.ALIAS === this.state.APIName); 
        var Validate = this.ValidateSaveQuickPay();
        if(Validate === false)
        {
            return false;
        }
        
        this.setState({
            loadingQuickPay: true
        });
        var result = APIService.SaveQuickPaySetting(CompanyCode,email, UserName, Pass, EasyApiUser, EasyApiPassword, PeoId, ClientId, ApiAddress, CustomFieldNameUserId,
                                                    CustomFieldNameLegacyEmployeeId, CustomFieldNameJobId, UseSalary, ProjAndJobAssignableToAll);
        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingQuickPay: false
                });
                var newList = {
                    ALIAS: QuickPay.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    ID: QuickPay.ID,
                    NAME: QuickPay.NAME,
                    VALUE: {
                        UserName: UserName,
                        Password: Pass,
                        EasyApiUser:EasyApiUser,
                        EasyApiPassword: EasyApiPassword,
                        PeoId:PeoId,
                        ClientId: ClientId,
                        ApiAddress:ApiAddress,
                        CustomFieldNameUserId: CustomFieldNameUserId,
                        CustomFieldNameLegacyEmployeeId: CustomFieldNameLegacyEmployeeId,
                        CustomFieldNameJobId: CustomFieldNameJobId,
                        UseSalary:UseSalary,
                        ProjAndJobAssignableToAll: ProjAndJobAssignableToAll,
                        Name:QuickPay.ALIAS
                    }
                };
                that.props.SetObject(newList);

                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingQuickPay: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingQuickPay: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {

            that.setState({
                loadingQuickPay: false,
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }
   
    render(){     
        
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div>
                            <div className="col-2 " >
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Use Salary</label>
                            </div>   
                            <div className="col-2" style={{ 'paddingTop': '15px'}}>
                                <Checkbox
                                    style={{ width: 25, height: 25 }}
                                    checked={this.state.UseSalary}
                                    onChange={this.handleUseSalary}
                                    color="primary"
                                />
                            </div>                             
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Easy API User</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="clientapiuser" id="clientapiuser" type="text" onChange={this.handleEasyApiUser}  value={ this.state.EasyApiUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Easy API Password</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="clientapipass" id="clientapipass" type={this.state.type} onChange={this.handleEasyApiPassword }   value={ this.state.EasyApiPassword}/>
                            </div>    
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                      
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API User(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="apiuser" id="apiuser" type="text" onChange={this.handleApiUser}  value={ this.state.APIUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="apipass" id="apipass" type={this.state.APIPasswordType} onChange={this.handleApiPass }   value={ this.state.APIPass}/>
                            </div>  
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHideAPIPasswordType}>{this.state.APIPasswordType === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Peo ID(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="peoId" id="peoId" type="text" onChange={this.handlePeoId } value={ this.state.PeoId}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client Id(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="clientID" id="clientID" type="text" onChange={this.handleClientID }  value={ this.state.ClientId}/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>API Access(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="ApiAddress" id="ApiAddress" type="text" onChange={this.handleApiAddress } value={ this.state.ApiAddress}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>UserId CustomField(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="CustomFieldNameUserId" id="CustomFieldNameUserId" type="text" onChange={this.handleCustomFieldNameUserId }  value={ this.state.CustomFieldNameUserId}/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Legacy CustomField(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="CustomFieldNameLegacyEmployeeId" id="CustomFieldNameLegacyEmployeeId" type="text" onChange={this.handleCustomFieldNameLegacyEmployeeId } value={ this.state.CustomFieldNameLegacyEmployeeId}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>JobId CustomField(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="CustomFieldNameJobId" id="CustomFieldNameJobId" type="text" onChange={this.handleCustomFieldNameJobId }  value={ this.state.CustomFieldNameJobId}/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">    
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Proj-Job to All</label>
                            </div>   
                            <div className="col-2" style={{ 'paddingTop': '15px'}}>
                                <Checkbox
                                    style={{ width: 25, height: 25 }}
                                    checked={this.state.ProjAndJobAssignableToAll}
                                    onChange={this.handleProjAndJobAssignableToAll}
                                    color="primary"
                                />
                            </div>           
                            <div className="col-2 offset-6"  size="sm" >
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingQuickPay}
                                />
                                {
                                    this.state.loadingQuickPay
                                    ?
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveQuickPay(e)} disabled>Save</Button>
                                    : 
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveQuickPay(e)}>Save</Button>
                                }
                               
                            </div>                             
                       </div>
                   </div>
                </div>
            </div>            
        );
    }
}

export default QuickPay;


// WEBPACK FOOTER //
// ./src/APIComponent/QuickPay.jsx